export default __webpack_public_path__ + "static/media/polymers.fc859107.jpg";